module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_library.js
// module id = 124
// module chunks = 2 92